/**
 * @module SelectProductControl
 */
import "./SelectProductControl.css";
import Control from 'ol/control/Control';

class SelectProductControl extends Control {

  constructor(opt_options) {
    const options = opt_options || {};

    // Create the container div
    const container = document.createElement('div');
    container.className = 'usa-dropdown-container ol-unselectable ol-control nhc-map-select-product html2canvas-ignore';

    // Create the toggle button
    const button = document.createElement('button');
    button.className = 'usa-button usa-button--unstyled nhc-map-select-product-button html2canvas-ignore';
    button.title = 'Select products';
    button.setAttribute('aria-expanded', 'false');
    button.innerHTML = `
      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img" width="24" height="24">
        <use href="assets/img/sprite.svg#list"></use>
      </svg>
      <span class="usa-sr-only">Toggle product selection</span>
    `;

    // Create the dropdown content
    const dropdown = document.createElement('div');
    dropdown.className = 'usa-dropdown nhc-map-select-product-content html2canvas-ignore';
    dropdown.hidden = true;

    dropdown.innerHTML = `
      <button id="select-product-close-button" class="usa-button usa-button--unstyled nhc-close-button">
        <span>Close menu</span>
        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
          <use xlink:href="assets/img/sprite.svg#close"></use>
        </svg>
      </button>
    `;

    // Create the product checklist
    const productList = document.createElement('ul');
    productList.className = 'nhc-map-product-list border-top border-gray-10 padding-top-1 margin-top-0 padding-x-2';
    options.products.forEach(product => {
      const listItem = document.createElement('li');
      listItem.className = 'nhc-map-product-list-item';
      const checked = (product.checked) ? " checked" : "";
      listItem.innerHTML = `
        <input type="checkbox" id="product-${product.id}" name="product-${product.id}" value="${product.id}"${checked}>
        <label for="product-${product.id}">${product.name}</label>
      `;
      productList.appendChild(listItem);
    });
    dropdown.appendChild(productList);

    // Add elements to container
    container.appendChild(button);
    container.appendChild(dropdown);

    super({
      element: container,
      target: options.target
    });

    // Store references to DOM elements
    this.container = container;
    this.button = button;
    this.dropdown = dropdown;
    this.closeButton = dropdown.querySelector('#select-product-close-button');
    this.productList = productList;

    // Bind event handlers
    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.toggleDropdown(e);
    });

    // Add event listener for product selection
    this.productList.addEventListener('change', (e) => {
      const productId = e.target.value;
      if (e.target.checked) {
        options.mapManager.addProduct(productId);
      } else {
        options.mapManager.removeProduct(productId);
      }
    });

    this.closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.closeDropdown(e);
    });

    // Add click outside listener to close dropdown
    document.addEventListener('click', (e) => {
      if (!this.container.contains(e.target)) {
        this.closeDropdown(e);
      }
    });
  }

  /**
   * Updates the language-specific elements.
   */
  updateLanguage() {
  }

  toggleDropdown(event) {
    const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
    this.button.setAttribute('aria-expanded', !isExpanded);
    this.dropdown.hidden = isExpanded;
  }

  closeDropdown(event) {
    this.button.setAttribute('aria-expanded', 'false');
    this.dropdown.hidden = true;
  }
}

export default SelectProductControl;